import {
  CreateMechanicDto,
  CreateMechanicWithUserDto,
  Mechanic,
  UpdateMechanicDto,
} from '../../types';
import api from './client';

// Mechanics Service
export const mechanicsService = {
  createMechanic: async (mechanic: CreateMechanicDto): Promise<Mechanic> => {
    const response = await api.post<Mechanic>('/mechanics', mechanic);
    return response.data;
  },
  createMechanicWithUser: async (mechanicWithUser: CreateMechanicWithUserDto): Promise<Mechanic> => {
    const response = await api.post<Mechanic>('/mechanics/with-user', mechanicWithUser);
    return response.data;
  },
  getAllMechanics: async (): Promise<Mechanic[]> => {
    const response = await api.get<Mechanic[]>('/mechanics');
    return response.data;
  },
  getAvailableMechanics: async (shopId: string): Promise<Mechanic[]> => {
    const response = await api.get<Mechanic[]>(`/mechanics/available?shopId=${shopId}`);
    return response.data;
  },
  getMechanicById: async (id: string): Promise<Mechanic> => {
    const response = await api.get<Mechanic>(`/mechanics/${id}`);
    return response.data;
  },
  getMechanicByUserId: async (userId: string): Promise<Mechanic> => {
    const response = await api.get<Mechanic>(`/mechanics/user/${userId}`);
    return response.data;
  },
  updateMechanic: async (id: string, updateData: UpdateMechanicDto): Promise<Mechanic> => {
    const response = await api.patch<Mechanic>(`/mechanics/${id}`, updateData);
    return response.data;
  },
  deleteMechanic: async (id: string): Promise<void> => {
    await api.delete(`/mechanics/${id}`);
  },
};
